import { CHCPhoneNumber } from "./phone-number.component.js";
customElements.define("chc-phone-number", CHCPhoneNumber);
export {
  CHCPhoneNumber
};
//# sourceMappingURL=phone-number.js.map
